document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.faq-item');
  function closeItem(item) {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!answer || !btn) return;

    // prepare collapse animation from current height
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.getBoundingClientRect();
    requestAnimationFrame(() => {
      answer.style.maxHeight = '0';
    });

    item.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');

    const onEnd = function(e) {
      if (e.propertyName === 'max-height') {
        answer.hidden = true;
        answer.removeEventListener('transitionend', onEnd);
      }
    };
    answer.addEventListener('transitionend', onEnd);
  }

  function openItem(item) {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!answer || !btn) return;

    answer.hidden = false;
    const height = answer.scrollHeight;
    answer.style.maxHeight = '0';
    answer.getBoundingClientRect();
    requestAnimationFrame(() => {
      answer.style.maxHeight = height + 'px';
    });

    item.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');

    const onEnd = function(e) {
      if (e.propertyName === 'max-height') {
        answer.style.maxHeight = 'none';
        answer.removeEventListener('transitionend', onEnd);
      }
    };
    answer.addEventListener('transitionend', onEnd);
  }

  // Initialize items and attach handlers
  faqItems.forEach(item => {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    const toggle = item.querySelector('.faq-toggle');

    if (answer) {
      answer.hidden = true;
      answer.style.maxHeight = '0';
      answer.style.overflow = 'hidden';
    }

    // Clicking the question opens it (but does not close it)
    // btn.addEventListener('click', function(e) {
    //   const isOpen = item.classList.contains('open');
    //   if (!isOpen) {
    //     openItem(item);
    //   }
    // });

    // Clicking the small toggle (X) closes the item
    // if (toggle) {
    //   toggle.addEventListener('click', function(e) {
    //     e.stopPropagation();
    //     if (item.classList.contains('open')) {
    //       closeItem(item);
    //     }
    //   });
    // }

    // Click on the whole item to toggle
    item.addEventListener('click', function(e) {
      // Prevent toggling if clicking on a link inside the answer (if any)
      if (e.target.tagName === 'A') return;

      const isOpen = item.classList.contains('open');
      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });

    // keyboard accessibility: Enter/Space opens
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        // Trigger the click on the item
        item.click();
      }
    });
  });
});